import hexToRGB from 'Utils/hexToRGB';
import store from 'Data/store';

/**
 * @param {mapboxGl.Map} map
 * @return {boolean}
 */
const addTransitionPointStyle = map => {
    const size = 180;
    let pulseColor = store.getState().pageState.layout.config?.settings?.mapConfig?.destinationPin
        ?.colors?.background;
    if (!pulseColor) {
        pulseColor = '#F50E55';
    }
    const pulseColorRgb = hexToRGB(pulseColor, 1, true);

    // This implements `StyleImageInterface` to draw a pulsing dot icon on the map.
    const pulsingDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),

        // When the layer is added to the map,
        // get the rendering context for the map canvas.
        onAdd() {
            const canvas = document.createElement('canvas');
            canvas.width = this.width;
            canvas.height = this.height;
            this.context = canvas.getContext('2d');
        },

        // Call once before every frame where the icon will be used.
        render() {
            const duration = 1500;
            const t = (performance.now() % duration) / duration;

            const radius = (size / 2) * 0.3;
            const outerRadius = (size / 2) * 0.4 * t + radius;
            const context = this.context;

            // Draw the outer circle.
            context.clearRect(0, 0, this.width, this.height);
            context.beginPath();
            context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
            context.fillStyle = `rgba(${pulseColorRgb}, ${1 - t})`;
            context.fill();

            // Update this image's data with data from the canvas.
            this.data = context.getImageData(0, 0, this.width, this.height).data;

            // Continuously repaint the map, resulting
            // in the smooth animation of the dot.
            map.triggerRepaint();

            // Return `true` to let the map know that the image was updated.
            return true;
        },
    };
    if (!map.hasImage('transition-point-pulsing')) {
        map.addImage('transition-point-pulsing', pulsingDot, {pixelRatio: 2});
    }
};

export default addTransitionPointStyle;
